import { withChartLayout } from 'components/common';
import CardiovascularPeripheralVascularInterventions from 'components/features/chart/system-nursing-interventions/cardiovascular/CardiovascularPeripheralVascularInterventions';

const CardiovascularPeripheralVascularInterventionsPage = withChartLayout('Cardiovascular - Peripheral Vascular Interventions')(CardiovascularPeripheralVascularInterventions);
export default CardiovascularPeripheralVascularInterventionsPage;
